module.exports = __webpack_public_path__ + "static/media/korean-alphabets-pattern.d052d179.JPG";